<template>
  <v-layout row justify-center>
    <v-dialog v-model="show" max-width="600px">
      <v-form id="newTicketForm">
        <v-card class="modern-modal">
          <div class="modal-head">
            <div class="modal-head-icon"><v-icon color="white">lock</v-icon></div>
            <span class="modal-head-title">Alterar Senha</span>
          </div>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Senha Atual"
                    v-model="params.currentPassword"
                    required
                    type="password"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Nova Senha"
                    v-model="params.newPassword"
                    required
                    type="password"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Confirmar Nova Senha"
                    v-model="params.newPasswordConfirm"
                    required
                    type="password"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="show = false" :disabled="loading">Cancelar</v-btn>
            <v-btn color="primary" @click="updatePassword" :loading="loading" :disabled="loading">Alterar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapGetters } from 'vuex';
import { EventBus } from '@/services/event-bus';

export default {
  name: 'NewTicket',
  data: () => ({
    show: false,
    params: {
      currentPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
    },
    rules: {
      required: value => !!value || 'Obrigatório.',
      min: v => v.length >= 8 || 'Mínimo de 8 caracteres',
      passwordEqConfirmation() {
        // eslint-disable-next-line
        if (self.confirmation === self.password) {
          return true;
        }
        return 'A senha e a confirmação são diferentes';
      },
      // emailMatch: () => ('The email and password you entered don\'t match')
    },
  }),
  watch: {
    show(newValue){
      if (newValue == false){
        this.params.currentPassword = '';
        this.params.newPassword = '';
        this.params.newPasswordConfirm = '';
      }
    }
  },
  created() {
    EventBus.$on('show-change-password-form', () => {
      this.show = true;
    });
    EventBus.$on('hide-change-password-form', () => {
      this.show = false;
    });
  },
  computed: {
    ...mapGetters({
      newTicketId: 'tickets/newTicketId',
      loading: 'account/loading',
    }),
  },
  methods: {
    async updatePassword() {
      if (this.params.newPassword !== this.params.newPasswordConfirm) {
        alert('A nova senha e a confirmação não coincidem');
        return;
      }
      
      try {
        await this.$store.dispatch('account/updatePassword', this.params);
        alert('Senha alterada com sucesso!');
        this.show = false;
      } catch (error) {
        console.error('Erro ao alterar senha:', error);
        alert('Erro ao alterar senha. Tente novamente.');
      }
    },
  },
};
</script>
